import { render, staticRenderFns } from "./DashboardQuantidadeRequisicao.vue?vue&type=template&id=3905d697&scoped=true&"
import script from "./DashboardQuantidadeRequisicao.vue?vue&type=script&lang=js&"
export * from "./DashboardQuantidadeRequisicao.vue?vue&type=script&lang=js&"
import style0 from "./DashboardQuantidadeRequisicao.vue?vue&type=style&index=0&id=3905d697&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3905d697",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
